import { render, staticRenderFns } from "./softProduct.vue?vue&type=template&id=5916f8fc&scoped=true"
import script from "./softProduct.vue?vue&type=script&lang=js"
export * from "./softProduct.vue?vue&type=script&lang=js"
import style0 from "./softProduct.vue?vue&type=style&index=0&id=5916f8fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916f8fc",
  null
  
)

export default component.exports